import React from "react";
import { Box, Typography, Button, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setTabIndex } from "../../ReduxStore/UserSlice";
import { useNavigate } from "react-router-dom";

const LoanEligibilityBanner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetail = useSelector((state) => state.user.user);

  const isLender = userDetail && 
    (userDetail.UserType || userDetail.userType || '').toLowerCase() === 'lender';

  if (isLender) {
    return null;
  }

  const handleCheckNowClick = () => {
    try {
      window.scrollTo(0, 0);
    dispatch(setTabIndex(7));
      navigate("/calculator");
    } catch (error) {
      navigate("/calculator");
    }
  };

  return (
    <Box
      sx={{
        width: { xs: "95%", sm: "90%" },
        maxWidth: { xs: "500px", sm: "750px", md: "1000px", lg: "1200px" },
        height: { xs: "auto", sm: "250px", md: "280px", lg: "300px" },
        minHeight: { xs: "200px", sm: "auto" },
        borderRadius: { xs: "8px", sm: "12px" },
        background: "linear-gradient(270deg, #0092E4 0%, #66A4FF 100%)",
        margin: { xs: "15px auto", sm: "20px auto" },
        position: "relative",
        overflow: "hidden",
        padding: { xs: "15px", sm: "20px", md: "25px", lg: "30px" },
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
        justifyContent: { xs: "center", sm: "space-between" },
        boxSizing: "border-box",
      }}
    >
      {/* Left content - Text and button */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: { xs: "center", sm: "flex-start" },
          justifyContent: "center",
          width: { xs: "100%", sm: "60%" },
          zIndex: 1,
        }}
      >
        {/* Title */}
        <Typography
          component="h2"
          sx={{
            width: "100%",
            fontFamily: "Open Sans",
            fontWeight: 800,
            fontSize: { xs: "18px", sm: "22px", md: "28px", lg: "30px" },
            lineHeight: { xs: "110%", sm: "120%" },
            letterSpacing: "0%",
            textDecoration: "underline",
            textDecorationStyle: "solid",
            textDecorationThickness: "10%",
            color: "#FFFFFF",
            mb: { xs: "10px", sm: "10px", md: "15px" },
            textAlign: { xs: "center", sm: "left" },
          }}
        >
          Know Your Loan Eligibility Instantly
        </Typography>

        {/* Subtitle */}
        <Typography
          sx={{
            width: "100%",
            fontFamily: "Open Sans",
            fontWeight: 600,
            fontStyle: "italic",
            fontSize: { xs: "13px", sm: "15px", md: "20px", lg: "24px" },
            lineHeight: { xs: "120%", sm: "120%" },
            letterSpacing: "0%",
            color: "#FFFFFF",
            mb: { xs: "15px", sm: "20px", md: "25px" },
            textAlign: { xs: "center", sm: "left" },
          }}
        >
          We help you estimate your business loan eligibility in seconds.
        </Typography>

        {/* Button */}
        <Button
          variant="contained"
          onClick={handleCheckNowClick}
          sx={{
            width: { xs: "60%", sm: "140px", md: "160px", lg: "180px" },
            height: { xs: "40px", sm: "40px", md: "45px", lg: "50px" },
            borderRadius: "8px",
            padding: { xs: "6px 15px", sm: "6px 15px", md: "8px 20px", lg: "8px 25px" },
            background: "#004AAD",
            "&:hover": {
              background: "#003c8a",
            },
            "& .MuiTypography-root": {
              fontFamily: "Open Sans",
              fontWeight: 600,
              fontSize: { xs: "13px", sm: "14px", md: "16px", lg: "18px" },
              color: "#FFFFFF",
            },
            mx: { xs: "auto", sm: "0" },
          }}
        >
          <Typography>Check Now</Typography>
        </Button>
      </Box>

      {/* Right content - Image */}
      <Box
        component="img"
        src="/CheckEligibilityLogo.png"
        alt="Check Eligibility"
        sx={{
          width: { xs: "120px", sm: "150px", md: "200px", lg: "220px" },
          height: { xs: "100px", sm: "130px", md: "180px", lg: "200px" },
          objectFit: "contain",
          mt: { xs: "10px", sm: 0 },
          mr: { sm: "5px", md: "20px", lg: "30px" },
        }}
      />
    </Box>
  );
};

export default LoanEligibilityBanner; 